<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'ThreeYearAreasChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      // id: 'chart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '（2020年4月26日）',
          left: 'right'
        },
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          dimensions: ['insurance', '2018年', '2019年', '2020年'],
          source: [
            { insurance: '阳光保险', '2018年': 1000, '2019年': 1500, '2020年': 1200 },
            { insurance: '太平洋保险', '2018年': 2000, '2019年': 1800, '2020年': 1600 },
            { insurance: '安信保险', '2018年': 5000, '2019年': 2000, '2020年': 3000 },
            { insurance: '平安保险', '2018年': 10000, '2019年': 5000, '2020年': 8000 }

          ]
        },
        legend: {
          top: 10,
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // data: ["2018年", "2019年", "2020年"]
        },
        grid: {
          right: 50
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // data: ["阳光保险 ", "太平洋保险", "安信保险", "平安保险"],

            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#aaa',
                type: 'dotted'
              }
            },
            axisLabel: {
              color: '#333',
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: {
              show: false
            }
          }
        ],
        color: ['#6f7dfa', '#4ab1e9', '#13d7d6'],
        series: [
          {
            type: 'bar',
            barWidth: 14
            // name: "2018年",
            // data: [1000, 2000, 5000, 10000],
          },
          {
            type: 'bar',
            barWidth: 14
            // data: [1500, 1800, 3000, 5000],
            // name: "2019年"

          },
          {
            type: 'bar',
            barWidth: 14
            // data: [1200, 1600, 2000, 8000],
            // name: "2020年"

          }
        ]
      }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },

    initMap (optionData) {
      // 设置时间
      if (optionData.date) {
        this.option.title.subtext = optionData.date || ''
      }
      this.option.dataset = optionData || []
      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/ThreeYearAreasChart.vue